import { FC, useState } from "react"
import { Alert } from "react-bootstrap";
import { ContactForm } from "./ContactForm";

type Props = {
    visibilityOfAlertWindow?: boolean,
    //colorOfAlertWindow?: boolean,
    message: string,
    onClose: () => void
}
export const SystemMessage: FC<Props> = ({ visibilityOfAlertWindow, message, onClose }) => {

    //console.log(visibilityOfAlertWindow);
    //console.log(message);
    //console.log(colorOfAlertWindow)


    return (
        <>
            <Alert variant={"primary"} show={visibilityOfAlertWindow}>
                <Alert.Heading>{message}</Alert.Heading>

            </Alert>
        </>
    )
}